var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyHeart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14451 17.3922C9.27985 17.5276 9.46342 17.6036 9.65483 17.6036C9.84624 17.6036 10.0298 17.5276 10.1651 17.3922L16.2467 11.3106C17.9198 9.63755 17.9198 6.92495 16.2467 5.25186C14.5736 3.57878 11.861 3.57878 10.1879 5.25186L10.1879 5.25188L9.65481 5.785L9.12167 5.25186C7.44859 3.57878 4.73598 3.57878 3.0629 5.25186C1.38981 6.92495 1.38981 9.63755 3.0629 11.3106L9.14451 17.3922Z",
    fill: "#A6A8AC",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyHeart);
export default __webpack_public_path__ + "static/media/GreyHeart.ce6beec8cb8313294129855883365562.svg";
export { ForwardRef as ReactComponent };